import { Messages } from '../../../codegen/Localize';
import { Order } from '../../../ts/helpers/Order';
import { OrderKeys } from '../../../ts/models/OrderKeys';
import { SortOptions } from '../../../ts/models/sort/CommonSortOptions';
import { OptionDefinition, OptionsDictionary } from '../../../ts/models/sort/SortOptionDefinitions';

const workbookCountSortOption: OptionDefinition = {
  id: 'workbooks',
  getMenuItemDisplayValue: Messages.column_numWorkbooks,
  subSortOptions: {
    'desc': {
      id: 'workbooks.desc',
      field: OrderKeys.connectedWorkbooksCount,
      getMenuItemDisplayValue: Messages.sortByMostLeast,
      getButtonDisplayValue: Messages.sortByNumWorkbooksDesc,
      ascending: false,
      toOrderClauseArray: () => [Order.desc(OrderKeys.connectedWorkbooksCount), Order.asc(OrderKeys.name)]
    },
    'asc': {
      id: 'workbooks.asc',
      field: OrderKeys.connectedWorkbooksCount,
      getMenuItemDisplayValue: Messages.sortByLeastMost,
      getButtonDisplayValue: Messages.sortByNumWorkbooksAsc,
      ascending: true,
      toOrderClauseArray: () => [Order.asc(OrderKeys.connectedWorkbooksCount), Order.asc(OrderKeys.name)]
    }
  }
};

// for searching, only
export const isCertifiedSortOption: OptionDefinition = {
  id: 'isCertified.desc',
  field: OrderKeys.isCertified,
  getMenuItemDisplayValue: () => Messages.sortByIsCertified(),
  getButtonDisplayValue: () => Messages.sortByIsCertified(),
  ascending: false,
  toOrderClauseArray: () => [{field: OrderKeys.isCertified, ascending: false}]
};

export const datasourceSortOptions: OptionsDictionary = {
  'relevance': SortOptions.relevance,
  'name': SortOptions.name,
  'hits': SortOptions.hits,
  'workbooks': workbookCountSortOption,
  'containerName': SortOptions.containerName,
  'owner': SortOptions.owner,
  'refresh': SortOptions.datasourceRefresh,
  'updated': SortOptions.updated,
  'modifiedBy':  SortOptions.modifiedBy,
  'alert': SortOptions.alert
};

export const datasourceSortOptionsForSearch: OptionsDictionary = {
  'isCertified': isCertifiedSortOption,
  ...datasourceSortOptions
};


